import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import utils from 'helpers/utils';
import {
    fetchTransactionQuotes,
} from 'store/actions/transactions/fetchTransactions';
import { connect } from 'react-redux';
import { selectTransactionQuote } from 'store/actions/transactions/selectTransactions';

const styles = {
    item: {
        container: {
            height: '50px',
            margin: '20px 0 0 0',
            backgroundColor: 'rgba(220, 247, 251, 1)',
        },
        costs: {
            flexBasis: '40%',
            minWidth: '200px',
        },
        inner: {
            display: 'flex',
            justifyContent: 'space-around',
        },
        selected: {
            backgroundColor: 'rgba(184, 215, 220, 1)',
        },
        title: {
            flexBasis: '60%',
            minWidth: '400px',
        },
    },
    label: {
        display: 'flex',
    },
    list: {
        display: 'flex',
        flexBasis: '100%',
        flexDirection: 'column',
        flexWrap: 'wrap',
    },
    wrapper: {
        margin: '20px 0',
    },
};

class TransactionPaymentMethodsContainer extends React.Component {
    shouldComponentUpdate(nextProps) {
        const {
            selected,
        } = this.props;

        if (!utils.isEmpty(nextProps.quotes) || nextProps.selected !== selected) {
            return true;
        }

        return false;
    }

    componentDidMount() {
        const {
            goToPrevious,
            handleFetchQuotes,
            quotes,
            transactionId,
        } = this.props;

        if (!transactionId) {
            return goToPrevious && goToPrevious();
        }

        if (utils.isEmpty(quotes)) {
            handleFetchQuotes(transactionId);
        }
    }

    componentDidUpdate() {
        const {
            dispatchLoaderOff,
            loading,
            quotes,
        } = this.props;

        if (loading && !utils.isEmpty(quotes)) {
            return dispatchLoaderOff();
        }
    }

    handleSelectedQuote = (index) => {
        const {
            dispatchSelectedIndex,
        } = this.props;

        dispatchSelectedIndex(index);
    }

    render() {
        const {
            quotes,
            selected,
        } = this.props;

        const {
            locale,
        } = this.context;

        if (utils.isEmpty(quotes)) {
            return null;
        }

        return (
            <form>
                <div style={ styles.list }>
                    {
                        quotes.map((item, index) => {
                            const styledButton = (selected === index) ?
                                Object.assign({}, styles.item.container, styles.item.selected) :
                                styles.item.container;

                            return (
                                <FlatButton
                                    hoverColor='rgba(184, 215, 220, 1)'
                                    key={ item.payment_method }
                                    labelStyle={ styles.label }
                                    labelPosition='after'
                                    onClick={ () => {
                                        return this.handleSelectedQuote(index);
                                    } }
                                    style={ styledButton }
                                >
                                    <div style={ styles.item.inner }>
                                        <div style={ styles.item.title }>{ item.title }</div>

                                        <div style={ styles.item.costs }>{ utils.formatPrice(item.costs, 'EUR', locale) }</div>
                                    </div>
                                </FlatButton>
                            );
                        })
                    }
                </div>
            </form>
        );
    }
}

TransactionPaymentMethodsContainer.contextTypes = {
    locale: PropTypes.string,
};

TransactionPaymentMethodsContainer.propTypes = {
    dispatchLoaderOff: PropTypes.func.isRequired,
    dispatchSelectedIndex: PropTypes.func.isRequired,
    goToPrevious: PropTypes.func,
    handleFetchQuotes: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    quotes: PropTypes.array,
    selected: PropTypes.number,
    transactionId: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => {
    return {
        quotes: state.transactions.quotes,
    };
};

const mapsDispatchToProps = (dispatch, props) => {
    const {
        dispatchLoaderOn,
        onSelectedQuote,
    } = props;

    return {
        dispatchSelectedIndex: (index) => {
            dispatchLoaderOn();

            dispatch(selectTransactionQuote(index));
            onSelectedQuote();
        },
        handleFetchQuotes: (transactionId) => {
            dispatchLoaderOn();

            setTimeout(() => {
                dispatch(fetchTransactionQuotes({
                    id: transactionId,
                }));
            }, 1500);
        },
    };
};

export default connect(
    mapStateToProps,
    mapsDispatchToProps,
)(TransactionPaymentMethodsContainer);



// WEBPACK FOOTER //
// ./src/components/transaction/TransactionPaymentMethodsContainer.js